import { useEffect, useState } from "react";
import { Tags } from "lucide-react";
import { api } from "@/lib/api";
import { GROUP_LABELS, type Category, type CategoryGroup } from "@/lib/finance";
import { SettingsSection } from "./SettingsSection";

const ORDER: CategoryGroup[] = ["income", "savings_investment", "essentials", "comfort"];
const TITLES: Record<CategoryGroup, string> = { ...GROUP_LABELS, income: "Ingresos" };

export function CategoryGuide() {
  const [cats, setCats] = useState<Category[] | null>(null);
  useEffect(() => { api.get<Category[]>("/categories").then((r) => setCats(r.data)).catch(() => setCats([])); }, []);
  return (
    <SettingsSection id="categorias" icon={Tags} title="Qué va en cada categoría" desc="Las categorías son las mismas para todos. Úsalas como guía para saber dónde va cada movimiento.">
      {!cats ? <div className="h-40 animate-pulse rounded-lg bg-[#F4F5F7]" /> : (
        <div className="space-y-6" data-testid="category-guide">
          {ORDER.map((g) => {
            const rows = cats.filter((c) => c.group === g);
            if (!rows.length) return null;
            return (
              <div key={g}>
                <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500">{TITLES[g]}</p>
                <ul className="divide-y divide-[#DDE1E8] rounded-xl border border-[#DDE1E8]">
                  {rows.map((c) => (
                    <li key={c.id} className="px-4 py-3" data-testid={`category-guide-${c.id}`}>
                      <p className="font-semibold text-[#1B2A4A]">{c.name}</p>
                      {c.description && <p className="mt-0.5 text-sm text-slate-500">{c.description}</p>}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      )}
    </SettingsSection>
  );
}
